import React from 'react';
import BoldText from "../text/BoldText";

class InterventionVehicle extends React.Component {

  render() {
    const {carVin, carPlate} = this.props;

    return (
      <div>
        <BoldText text={carVin} boldEndCharacters={7}/>
        <br/>
        {carPlate}
      </div>
    )
  }
}

export default InterventionVehicle;
